import * as React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */ "@omni/components/components/Product/SafetyInfo/safetyInfo.container"
    ).then((module) => ({
        default: module.SafetyInfoContainer
    }))
);
